module.exports = __webpack_public_path__ + "img/epr-price@2x.fce4fdfa.webp";